import BookingWizard from '../../views/apps/booking';
import AppointmentsApp from '../../views/apps/appointments';
import AccountApp from '../../views/apps/account';
import PetsApp from '../../views/apps/pets';

const AppRoutes = [
  {
    path: '/:clientId/account',
    component: AccountApp,
    exact: true,
    meta: {
      menuHidden: true,
    },
  },
  {
    path: '/:clientId/pets',
    component: PetsApp,
    exact: true,
    meta: {
      menuHidden: true,
      publicRoute: true,
    },
  },
  {
    path: ['/:clientId/appointments', '/:clientId/appointments/:appointmentId', '/:clientId/appointments/:appointmentId/reschedule'],
    component: AppointmentsApp,
    exact: true,
    meta: {
      menuHidden: true,
    },
  },
  {
    path: ['/:clientId', '/:clientId/:paymentId'],
    component: BookingWizard,
    exact: true,
    meta: {
      menuHidden: true,
      publicRoute: true,
    },
  },
];

export default AppRoutes;
